var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-message"},[_c('p',[_vm._v("Cargando...")]),_vm._v(" "),_c('p',[_vm._v("Esto podría tardar unos segundos.")]),_vm._v(" "),_c('i',{staticClass:"fas fa-spinner fa-spin"})])])
}]

export { render, staticRenderFns }